import {clsx} from '@mantine/core'
import {FC, useContext, useEffect, useMemo, useState} from 'react'
import {Link, useLocation, useParams} from 'react-router-dom'
import roleContext from '../../../../app/context/roleContext'
import {setupAxios, useAuth} from '../../../../app/modules/auth'
import AdminAttendance from '../../../../app/pages/attendance/AdminAttendance'
import Application from '../../../../app/pages/attendance/Application'

import {getUserByIdForAMS} from '../../../../app/pages/attendance/ams'
import Overviews from '../../../../app/pages/organization/project/Overviews'
import ProjectOverview from '../../../../app/pages/organization/project/ProjectOverview'
import Defects from '../../../../app/pages/organization/task/Defects'
import Task from '../../../../app/pages/organization/task/Task'
import Users from '../../../../app/pages/organization/users/Users'
import Role from '../../../../app/pages/role/Role'
import User from '../../../../app/pages/user/User'
import {RoleContextValue} from '../../../../app/types/OtherTypes'
import {API_BASE_URL} from '../../../../utils/contants'
import {checkRole} from '../../../helpers/AssetHelpers'
import {useLayout} from '../../core'
import Designation from '../../../../app/pages/designation/Designation'
import GeneralSetting from '../../../../app/pages/setting/GeneralSetting'
import LeaveSetting from '../../../../app/pages/setting/LeaveSetting'
import EmploymentTypes from '../../../../app/pages/employment-types/EmploymentTypes'
import ShiftManagement from '../../../../app/pages/ShiftManagement/ShiftManagement'
//import ShiftManagements from './ShiftManagements'




const Toolbar1: FC = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const location = useLocation()
  const {currentUser} = useAuth()
  const isSuperAdmin =
  roleState.roleName === 'Super Admin' ||
  roleState.roleName === 'SUPER_ADMIN'

  const isAdmin = roleState.roleName === 'Admin'

  const isRm =
    currentUser?.isRmOrHr === true &&
    !(currentUser?.designation?.name || '')
      .toUpperCase()
      .includes('HR')

  const canAccessProjectTabs = isSuperAdmin || isAdmin || isRm


  const params = useParams()
  const isAttendanceRoute = location.pathname === '/ams'
  const isUser = location.pathname === '/users'
  const isProjectOverview = location.pathname === `/projectOverview/${params?.id}`
  const isSetting = location.pathname === `/setting`
  const {classes} = useLayout()
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const today = new Date()
  const [user, setUser] = useState<any>(null)
  // const [tableData, setTableData] = useState<TableData[]>([])
  const [isProjectManager, setIsProjectManager] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(true)
  const [activeTab, setActiveTab] = useState(
    isProjectOverview
      ? 'projectOverview'
      : isUser
        ? checkRole(['users_registration'], roleState.features)
          ? 'user'
          : checkRole(['roles'], roleState.features)
            ? 'roles'
            : checkRole(['designations'], roleState.features)
              ? 'designation'
              : 'employment-type'
        : isSetting
          ? checkRole(['general_config'], roleState.features)
            ? 'general'
            : 'leave'
          : ''
  )
  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }

  // const fetchTableData = async (page = 1, take = 10) => {
  //   const {token, tenantId} = setupAxios()

  //   await fetch(API_BASE_URL + `/attendence?page=${page}&take=${take}`, {
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer ${token}`,
  //       'Content-Type': 'application/json',
  //       'X-tenant-Id': `${tenantId}`,
  //     },
  //     body: JSON.stringify({
  //       id: currentUser?.id,
  //     }),
  //   })
  //     .then(async (response) => {
  //       let res = await response.json()
  //       if (res.statusCode === 200) {
  //         setTableData([res.data])
  //       } else {
  //         setTableData([])
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching table data:', error)
  //     })
  // }
  // const fetchData = async () => {
  //   try {
  //     const {token, tenantId} = setupAxios()

  //     const response = await fetch(API_BASE_URL + `/check-manager/${currentUser?.id}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: `Bearer ${token}`,
  //         'X-tenant-Id': `${tenantId}`,
  //       },
  //     })

  //     const data = await response.json()

  //     setIsProjectManager(data.isProjectManager)
  //   } catch (error) {
  //     console.error('Error fetching project manager status', error)
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  useMemo(() => {
    setActiveTab(
      isProjectOverview
        ? 'projectOverview'
        : isUser
          ? checkRole(['users_registration'], roleState.features)
            ? 'user'
            : checkRole(['roles'], roleState.features)
              ? 'roles'
              : checkRole(['designations'], roleState.features)
                ? 'designation'
                : 'employment-type'
          : isSetting
            ? checkRole(['general_config'], roleState.features)
              ? 'general'
              : 'leave'
            : ''
    )

    if (isProjectOverview) {
      // fetchData()
    } else if (isAttendanceRoute) {
      // fetchTableData()
      getUserByIdForAMS(setUser, setAPIStatus, currentUser)
    }
  }, [isSetting, isProjectOverview, isUser, isAttendanceRoute])

  useEffect(() => {
    let mounted = true
    if (mounted) {
      if (isProjectOverview) {
        // fetchData()
      } else if (isAttendanceRoute) {
        // fetchTableData()
        getUserByIdForAMS(setUser, setAPIStatus, currentUser)
      }
    }
    return () => {
      mounted = false
    }
  }, [])
  return (
    <>
      <div className='toolbar mb-8' id='kt_toolbar'>
        <div
          id='kt_toolbar_container'
          className={clsx(classes.toolbarContainer.join(' '), 'd-flex justify-content-between')}
        >
          {isProjectOverview && (
            <div className='d-flex h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                {/* {checkRole(['Project Management'], roleState.features) && ( */}
                {canAccessProjectTabs && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'projectOverview',
                      })}
                      to=''
                      onClick={() => handleTabClick('projectOverview')}
                    >
                      Detail
                    </Link>
                  </li>
                )}
                {/* Overview Remove */}
                {/* {checkRole(['Project Management'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'overviews',
                      })}
                      to=''
                      onClick={() => handleTabClick('overviews')}
                    >
                      Overview
                    </Link>
                  </li>
                )} */}
                {/* {checkRole(['Project Management'], roleState.features) && ( */}
                {canAccessProjectTabs && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'users',
                      })}
                      to=''
                      onClick={() => handleTabClick('users')}
                    >
                      Member
                      {/* Users */}
                    </Link>
                  </li>
                )}
                {/* Task  */}
                {/* {checkRole(['Project Management'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'task',
                      })}
                      to=''
                      onClick={() => handleTabClick('task')}
                    >
                      Task
                    </Link>
                  </li>
                )} */}
                {/* Defect tab commented out */}
                {/* {checkRole(['Project Management'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'defect',
                      })}
                      to=''
                      onClick={() => handleTabClick('defect')}
                    >
                      Defect
                    </Link>
                  </li>
                )} */}
                {/* {projectData[0]?.projectManager?.id === currentUser?.id && ( */}
                {/* <li className='nav-item'>
                  <Link
                    className={clsx('nav-link text-active-primary me-4', {
                      active: activeTab === 'settings',
                    })}
                    to=''
                    onClick={() => handleTabClick('settings')}
                  >
                    Settings
                  </Link>
                </li> */}
                {/* )} */}
              </ul>
            </div>
          )}
          {/* <div className='flex-grow-1 flex-shrink-0  ms-5'> */}
          {isUser && (
            <div className='d-flex h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                {checkRole(['users_registration'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'user',
                      })}
                      to=''
                      onClick={() => handleTabClick('user')}
                    >
                      Users
                    </Link>
                  </li>
                )}
                {checkRole(['roles'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'roles',
                      })}
                      to=''
                      onClick={() => handleTabClick('roles')}
                    >
                      {/* Role */}
                      Permissions
                    </Link>
                  </li>
                )}
                {checkRole(['designations'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'designation',
                      })}
                      to=''
                      onClick={() => handleTabClick('designation')}
                    >
                      Designation
                    </Link>
                  </li>
                )}
                {checkRole(['employment_types'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'employment-type',
                      })}
                      to=''
                      onClick={() => handleTabClick('employment-type')}
                    >
                      Employment Type
                    </Link>
                  </li>
                )}
                {/* {checkRole(['users_registration'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'shift-management',
                      })}
                      to=''
                      onClick={() => handleTabClick('shift-management')}
                    >
                      Shift Management
                    </Link>
                  </li>
                )} */}
              </ul>
            </div>
          )}
          {isSetting && (
            <div className='d-flex h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                {checkRole(['general_config'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'general',
                      })}
                      to=''
                      onClick={() => handleTabClick('general')}
                    >
                      General
                    </Link>
                  </li>
                )}
                {checkRole(
                  ['leave_config', 'leave_types', 'leave_policies'],
                  roleState.features
                ) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'leave',
                      })}
                      to=''
                      onClick={() => handleTabClick('leave')}
                    >
                      Leave
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
          {/* </div> */}

          {/* <div className='flex-grow-1 flex-shrink-0 text-start'> */}
          {/* {isAttendanceRoute && (
            <div className='d-flex h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                {checkRole(['attendance_management_system'], roleState.features) && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'myAttendance',
                      })}
                      to=''
                      onClick={() => handleTabClick('myAttendance')}
                    >
                      My Attendance
                    </Link>
                  </li>
                )}

                {currentUser?.isRmOrHr && (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'allAttendance',
                      })}
                      to=''
                      onClick={() => {
                        handleTabClick('allAttendance')
                        // fetchTableData()
                      }}
                    >
                      Team Attendance
                    </Link>
                  </li>
                )}

                {isProjectManager ||
                currentUser?.designation?.name === 'HR Executive' ||
                currentUser?.email === 'hr@skeletos.in' ? (
                  <li className='nav-item'>
                    <Link
                      className={clsx('nav-link text-active-primary me-4', {
                        active: activeTab === 'applications',
                      })}
                      to=''
                      onClick={() => handleTabClick('applications')}
                    >
                      Applications
                    </Link>
                  </li>
                ) : (
                  <div></div>
                )}
              </ul>
            </div>
          )} */}
          {/* </div> */}
        </div>
      </div>
      <div className='mt-13'>
        {activeTab === 'projectOverview' && (
          <div className=''>
            <ProjectOverview />
          </div>
        )}
        {activeTab === 'overviews' && <Overviews />}
        {activeTab === 'users' && <Users />}
        {/* {activeTab === 'myAttendance' && <AdminAttendance />}
        {activeTab === 'allAttendance' && <Attendance />} */}
        {activeTab === 'applications' && <Application />}
        {/* {activeTab === 'settings' && <Settings setProjectData={setProjectData} />} */}
        {activeTab === 'task' && <Task />}
        {/* {activeTab === 'defect' && <Defects />} */}
        {activeTab === 'user' && <User />}
        {activeTab === 'roles' && <Role />}
        {activeTab === 'designation' && <Designation />}
        {activeTab === 'general' && <GeneralSetting />}
        {activeTab === 'leave' && <LeaveSetting />}
        {activeTab === 'employment-type' && <EmploymentTypes />}
        {activeTab === 'shift-management' && <ShiftManagement />}


      </div>
    </>
  )
}

export {Toolbar1}
